export default "__VITE_ASSET__CcGjxpGp__"